<template>
    <section id="footer-wrapper">
        <div class="footer-section">
            <h3 class="title">Idiomas</h3>
            <div class="content languages">
                <a @click.prevent="$store.commit('changeLang','en')" href="#">
                    <img src="../assets/images/icons/usa-flag.png" alt="Enlgish">
                </a>
                <a @click.prevent="$store.commit('changeLang','es')" href="#">
                    <img src="../assets/images/icons/spain-flag.png" alt="Español">
                </a>
            </div>
        </div>
        <div class="footer-section">
            <h3 class="title">Dirección</h3>
            <div class="content">
                <p>Carretera La Ceiba - Jutiapa
                    <br>
                    frente a los Juzgados Ceibeños,
                    <br>
                    entrada Colonia Villa Gabriela</p>
            </div>
        </div>
        <div class="footer-section">
            <h3 class="title">Números de Teléfono</h3>
            <div class="content phone-numbers">
                <ul>
                    <li><a href="tel:+504 2440-5298">+504 2440-5298</a></li>
                    <li><a href="tel:+504 9699-0886">+504 9699-0886</a></li>
                    <li><a href="tel:+504 3197-7595">+504 3197-7595</a></li>
                </ul>
            </div>
        </div>
        <div class="footer-section">
            <h3 class="title">Redes Sociales</h3>
            <div class="content social">
                <a href="https://www.facebook.com/hotellashamacas/" target="_blank">
                    <img src="../assets/images/icons/facebook-scaled.png" alt="Facebook Logo">
                </a>
                <a href="https://www.instagram.com/hotel_las_hamacas/" target="_blank">
                    <img src="../assets/images/icons/insta-scaled.png" alt="Instagram Logo">
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
    #footer-wrapper {
        background-color: #643229;
        display: flex;
        border-top: 1px solid #643229;
        padding: 20px;
        justify-content: space-evenly;
        color: #FFF;
    }

    #footer-wrapper .title {
        text-align: center;
        font-size: 1.3rem;
        font-weight: 600;
    }

    #footer-wrapper .content {
        font-size: 1.1rem;
        font-weight: 400;
        text-align: center;
    }

    #footer-wrapper .content ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    #footer-wrapper .content.phone-numbers a {
        text-decoration: none;
        color: #FFF;
    }

    #footer-wrapper .social, #footer-wrapper .languages {
        display: flex;
        justify-content: space-evenly;
    }

    #footer-wrapper .social img, #footer-wrapper .languages img {
        width: 45px;
        margin-right: 5px;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        #footer-wrapper {
            flex-direction: column;
        }

        #footer-wrapper .content.phone-numbers li {
            padding: 5px 0;
        }

        #footer-wrapper .content.phone-numbers a {
            color: #ff9a3c;
        }
    }
</style>
